import React, { useEffect, useState } from "react";
import objectPath from "object-path";
import update from "immutability-helper";
import deepmerge from "deepmerge";
import { Address } from "qjumpers.common.ui";
import { Utils } from "react-jsonschemapath-form";
import { getUiOptions } from "react-jsonschema-form/lib/utils";
import { loadCitiesByCountryStateCode, loadCountries, loadStates, loadZipCodesByCountry } from "../../requests/locations";
import { isEmpty } from "lodash";
import environmentConfig from "../../constants/config";

const AddressComponent = (props) => {
  const defaultCountryCode = environmentConfig.host.indexOf("qjumpersjobs") > -1 ? "NZ" : "US";

  const values = props.uiSchema.values;
  const defaultCountry = values[0].schema.default;
  const checkShowStates = (currentCountry) => {
    const getShowStates = values[0].schema.showStates;
    const showStates = getShowStates;
    const showStatesList = showStates && showStates.length > 0 ? showStates.split(",") : [];
    let result = false;
    if (showStatesList) {
      showStatesList.map((stateCountry) => {
        if (stateCountry === currentCountry) {
          result = true;
        }
      });
    }
    return result;
  };

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [zipCodes, setZipCodes] = useState([]);

  const [stateData, setLocationState] = useState();
  useEffect(() => {
    const country = objectPath.get(props.formData, values[0].key);
    const state = objectPath.get(props.formData, values[1].key);
    const city = objectPath.get(props.formData, values[2].key);
    const zipCode = objectPath.get(props.formData, values[3].key);
    const stateCode = objectPath.get(props.formData, values[4].key);
    const streetAddress = objectPath.get(props.formData, values[5].key);
    const region = objectPath.get(props.formData, values[6].key);
    const locationCode = objectPath.get(props.formData, values[7].key);
    const options = getUiOptions(props.uiSchema.schema || {});
    const currentCountry = country || defaultCountryCode;
    const unSecureApiCall = false || values[0].schema.unSecureApiCall;
    const showStates = checkShowStates(currentCountry);
    setLocationState({
      country: {
        key: values[0].key,
        value: country || defaultCountryCode,
      },
      state: {
        key: values[1].key,
        value: state,
      },
      city: {
        key: values[2].key,
        value: city,
      },
      zipCode: {
        key: values[3].key,
        value: zipCode,
      },
      stateCode: {
        key: values[4].key,
        value: stateCode,
      },
      streetAddress: {
        key: values[5].key,
        value: streetAddress,
      },
      region: {
        key: values[6].key,
        value: defaultCountry === country || !region ? "Default" : region,
      },
      locationCode: {
        key: values[7].key,
        value: locationCode,
      },
      isOversea: defaultCountry != currentCountry,
      showStates: showStates,
      unSecureApiCall: unSecureApiCall,
      options: options,
    });
  }, []);

  useEffect(() => {
    if (stateData) {
      loadLocations();
    }
  }, [stateData]);

  useEffect(() => {
    if (stateData) {
      const country = objectPath.get(props.formData, values[0].key) || defaultCountryCode;
      const isOversea = country != "NZ";
      const state = objectPath.get(props.formData, values[1].key);
      const city = objectPath.get(props.formData, values[2].key);
      const zipCode = objectPath.get(props.formData, values[3].key);
      const stateCode = objectPath.get(props.formData, values[4].key);
      const streetAddress = objectPath.get(props.formData, values[5].key);
      const region = objectPath.get(props.formData, values[6].key);
      const locationCode = objectPath.get(props.formData, values[7].key);
      const showStates = checkShowStates(country);

      let newState = update(
        stateData,
        deepmerge.all([
          Utils.getPatch("country.value", country),
          Utils.getPatch("state.value", state),
          Utils.getPatch("city.value", city),
          Utils.getPatch("zipCode.value", zipCode),
          Utils.getPatch("stateCode.value", stateCode),
          Utils.getPatch("streetAddress.value", streetAddress),
          Utils.getPatch("region.value", region),
          Utils.getPatch("locationCode.value", locationCode),
        ])
      );
      newState = {
        ...newState,
        isOversea,
        showStates,
      };
      setState(newState);
    }
  }, [props]);

  const setState = (options) => {
    setLocationState({
      ...stateData,
      ...options,
    });
  };

  const loadLocations = () => {
    const { country, state, stateCode, city, showStates } = stateData;
    if (!countries || countries.length == 0) {
      loadCountries().then((result) => setCountries(result?.data));
    }
    if (showStates) {
      if (isEmpty(states) || !states[country.value]) {
        loadStates(country.value).then((result) => {
          setStates({ [country.value]: result?.data });
        });
      }

      const stateCodeValue = stateCode.value || getStateCode(country.value, state.value);
      if (stateCodeValue) {
        if (!cities[stateCodeValue]) {
          loadCitiesByCountryStateCode(country.value, stateCodeValue).then((result) => setCities({ [stateCodeValue]: result?.data }));
        }

        if (city.value && !zipCodes[city.value]) {
          loadZipCodesByCountry(country.value, stateCodeValue, city.value).then((result) => {
            setZipCodes({ [city.value]: result?.data });
          });
        }
      }
    }
  };

  const getStateCode = (country, state) => {
    if (states[country]) {
      const stateDetail = states[country].find((s) => s.value === state);
      return stateDetail ? stateDetail.id : null;
    }
  };

  const handleOnCountryChange = (val) => {
    if (props.onChange) {
      props.onChange(val);
    }
    if (val?.country?.value) {
      loadStates(val.country.value).then((result) => setStates({ [val.country.value]: result?.data }));
    }
  };

  const handleLoadStates = (val) => {
    if (val) {
      loadStates(val).then((result) => {
        setStates({ [val]: result?.data });
      });
    }
  };

  const handleLoadCitiesByCountryStateCode = (val, id) => {
    loadCitiesByCountryStateCode(val, id).then((result) => {
      setCities({ [id]: result?.data });
    });
  };

  const handleLoadZipCodesByCountry = (countryVal, statecodeVal, id) => {
    if (id && !zipCodes[id]) {
      loadZipCodesByCountry(countryVal, statecodeVal, id).then((result) => {
        setZipCodes({ [id]: result?.data });
      });
    }
  };

  return stateData && countries?.length > 0 ? (
    <Address
      {...props}
      initialData={stateData}
      loadStateData={states}
      loadCountryData={countries}
      loadZipCodesByCountryData={zipCodes}
      loadCityData={cities}
      loadLocationStateData={stateData}
      defaultCountry={defaultCountry}
      onChange={(val) => handleOnCountryChange(val)}
      getLoadCitiesByCountryStateCode={(val, id) => handleLoadCitiesByCountryStateCode(val, id)}
      getLoadCountries={loadCountries}
      getLoadStates={(val) => handleLoadStates(val)}
      getLoadZipCodesByCountry={(countryVal, statecodeVal, id) => handleLoadZipCodesByCountry(countryVal, statecodeVal, id)}
      handleCheckShowStates={(countryVal) => checkShowStates(countryVal)}
    />
  ) : null;
};

export default AddressComponent;
